import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { Link } from 'react-router-dom';
import { Text } from '@mantine/core';
import { pdfFiles, PDFdownloadButton } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const Overview = () => {
  return (
    <VideoAndShowPDFAfter
      pdfFile={pdfFiles.introduction[0]}
      vidSrc={1198772464}
    />
  );
};

export default Overview;
